import { Injectable, NgZone, OnDestroy } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class ConnectivityService implements OnDestroy {

    private onlineSubject = new BehaviorSubject<boolean>(navigator.onLine)
    isOnline$ = this.onlineSubject.asObservable()

    private onOnline = () => this.ngZone.run(() => this.onlineSubject.next(true))
    private onOffline = () => this.ngZone.run(() => this.onlineSubject.next(false))

    constructor(private ngZone: NgZone) {
        window.addEventListener('online', this.onOnline)
        window.addEventListener('offline', this.onOffline)
    }

    get isOnline(): boolean {
        return this.onlineSubject.value
    }

    ngOnDestroy() {
        window.removeEventListener('online', this.onOnline)
        window.removeEventListener('offline', this.onOffline)
    }
}
